import { render, staticRenderFns } from "./user_tags_manager.vue?vue&type=template&id=db40524c&scoped=true"
import script from "./user_tags_manager.vue?vue&type=script&lang=ts"
export * from "./user_tags_manager.vue?vue&type=script&lang=ts"
import style0 from "./user_tags_manager.vue?vue&type=style&index=0&id=db40524c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db40524c",
  null
  
)

export default component.exports